export const SolidWire = [161,
    228,
    0,
    0,
    134,
    0,
    41,
    0,
    226,
    2,
    130,
    0,
    73,
    0,
    64,
    224,
    104,
    0,
    138,
    0,
    70,
    225,
    170,
    0,
    230,
    10,
    197,
    40,
    107,
    0,
    171,
    0,
    193,
    68,
    128,
    1,
    199,
    0,
    67,
    196,
    72,
    177,
    35,
    199,
    4,
    74,
    101,
    7,
    227,
    129,
    36,
    199,
    135,
    130,
    5,
    34,
    132,
    203,
    133,
    98,
    166,
    43,
    198,
    32,
    50,
    129,
    168,
    139,
    105,
    202,
    39,
    103,
    71,
    3,
    162,
    0,
    131,
    11,
    235,
    97,
    169,
    27,
    231,
    99,
    100,
    137,
    69,
    136,
    38,
    96,
    9,
    33,
    195,
    6,
    102,
    194,
    37,
    167,
    200,
    75,
    229,
    165,
    42,
    163,
    65,
    234,
    232,
    233,
    7,
    106,
    8,
    164,
    192,
    201,
    160,
    66,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]

export const LincolnPS =   [226,
    42,
    0,
    0,
    202,
    0,
    232,
    0,
    133,
    11,
    199,
    0,
    170,
    0,
    138,
    39,
    136,
    0,
    135,
    0,
    194,
    38,
    37,
    0,
    166,
    72,
    40,
    107,
    67,
    0,
    36,
    0,
    192,
    71,
    3,
    4,
    199,
    0,
    193,
    105,
    165,
    141,
    224,
    135,
    137,
    34,
    229,
    198,
    129,
    129,
    69,
    32,
    195,
    43,
    41,
    203,
    197,
    98,
    97,
    227,
    228,
    169,
    132,
    99,
    50,
    134,
    103,
    100,
    196,
    234,
    10,
    64,
    96,
    168,
    225,
    171,
    65,
    33,
    162,
    0,
    106,
    27,
    101,
    161,
    74,
    2,
    201,
    130,
    160,
    43,
    66,
    200,
    163,
    68,
    230,
    128,
    231,
    8,
    104,
    75,
    102,
    70,
    7,
    164,
    6,
    1,
    198,
    35,
    73,
    233,
    131,
    9,
    235,
    139,
    5,
    167,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    ]


    export const Degree_Welding_360 = [
        36, 4, 0, 0, 231, 0, 169, 0, 101, 66, 11, 0, 73, 0, 226, 232, 
        135, 0, 69, 0, 7, 75, 167, 0, 132, 230, 131, 136, 99, 0, 234, 0, 
        224, 228, 100, 235, 50, 0, 5, 138, 32, 16, 203, 124, 1, 68, 200, 
        145, 194, 129, 98, 170, 65, 228, 43, 96, 162, 130, 161, 202, 40, 
        139, 193, 195, 50, 160, 197, 102, 71, 67, 107, 163, 227, 196, 0, 
        34, 33, 133, 39, 97, 229, 129, 233, 3, 106, 164, 171, 38, 103, 74, 
        10, 35, 105, 37, 192, 134, 168, 225, 6, 64, 165, 129, 41, 2, 137, 
        72, 9, 8, 70, 42, 104, 198, 201, 199, 128, 166, 0, 0, 0, 0, 0, 0, 
        0, 0, 0, 0, 0, 0
    ];

    export const zone_to_zone_ramping = [
        0, 73, 0, 0, 9, 0, 104, 0, 70, 130, 133, 0, 201, 0, 230, 4, 10, 0, 165, 0, 
        229, 39, 194, 0, 64, 34, 170, 103, 38, 0, 100, 0, 35, 97, 227, 196, 50, 0, 
        2, 72, 43, 130, 202, 237, 200, 235, 197, 107, 74, 129, 163, 198, 171, 40, 
        232, 106, 136, 231, 195, 32, 66, 7, 96, 233, 50, 5, 67, 6, 105, 36, 102, 
        226, 33, 71, 37, 135, 192, 69, 132, 101, 166, 129, 41, 167, 40, 98, 75, 8, 
        224, 65, 203, 3, 139, 193, 128, 169, 138, 134, 131, 42, 234, 129, 107, 11, 
        137, 1, 228, 168, 161, 99, 199, 162, 225, 68, 160, 164, 0, 0, 0, 0, 0, 0, 
        0, 0, 0, 0, 0, 0
    ];

    export const touch_Ramp = [
        104, 134, 0, 0, 224, 0, 171, 0, 165, 170, 234, 0, 8, 0, 43, 198, 74, 0, 75, 0, 
        164, 68, 40, 0, 193, 97, 5, 34, 199, 0, 36, 0, 4, 228, 200, 166, 50, 0, 1, 65, 
        129, 165, 203, 28, 227, 70, 69, 127, 41, 129, 168, 130, 232, 195, 229, 72, 96, 
        135, 137, 139, 6, 132, 131, 128, 50, 192, 169, 103, 100, 9, 225, 196, 38, 71, 
        226, 35, 197, 233, 161, 107, 101, 129, 160, 64, 37, 10, 42, 3, 195, 66, 2, 67, 
        73, 0, 33, 194, 201, 136, 98, 102, 231, 105, 39, 202, 133, 167, 163, 32, 99, 
        162, 138, 7, 230, 106, 235, 11, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
    ];
    

    export const Fronius_TPSi = [
        168, 226, 0, 0, 198, 0, 202, 0, 101, 203, 99, 0, 0, 0, 98, 197, 73, 0, 135, 0, 
        97, 227, 199, 0, 1, 68, 134, 200, 171, 0, 128, 0, 201, 225, 43, 162, 50, 0, 
        38, 166, 193, 196, 106, 167, 224, 3, 36, 41, 74, 129, 233, 64, 160, 112, 232, 
        164, 137, 8, 167, 234, 231, 131, 161, 96, 50, 69, 104, 107, 102, 39, 37, 67, 
        2, 9, 100, 229, 6, 194, 65, 138, 235, 129, 11, 105, 133, 5, 169, 4, 32, 42, 
        72, 66, 139, 136, 70, 170, 132, 71, 34, 103, 130, 163, 40, 228, 10, 41, 35, 
        230, 192, 33, 129, 7, 196, 195, 75, 165, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
    ];
    